import { showSuccess, showError } from '../../index.js'
import axios from 'axios'
// import router from '@/router/index.js'

export default {
  namespaced: true,
  state () {
    return {
      users: []
    }
  },
  getters: {
    backendUsers (state) {
      return state.users.filter(item => item.deleted_at === null)
    }
  },
  mutations: {
    setUsers (state, payload) {
      state.users = payload
    }
  },
  actions: {
    async checkToken (context) {
      await context.rootState.authAxios.get('/Users/CheckToken').then((response) => {
      })
        .catch((error) => {
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            context.rootState.isLoggedIn = false
            context.rootState.isTrainee = false
            // context.rootState.authAxios = null
            context.rootState.userId = 0
            context.rootState.userRoles = []
            context.rootState.userPermissions = []
            context.rootState.userPermissionNames = []
            context.rootState.username = null
            context.rootState.email = ''
            context.rootState.token = null
            delete axios.defaults.headers.common.Authorization
            localStorage.removeItem('storeLocal')
            // router.push({ path: '/' })
          }
        })
    },
    async getUserData (context) {
      await context.rootState.authAxios.get('/Users').then((response) => {
        if (typeof response.data === 'string') {
          showError(response.data)
        } else {
          context.commit('setUsers', response.data)
        }
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getUserByPageWithFilter (context, { filteredTerm, filteredStatus, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      await context.rootState.authAxios.get('/Users/GetUsersByPageWithFilter', {
        params: {
          filteredTerm: filteredTerm,
          filteredStatus: filteredStatus,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData
        totalForPage = Math.ceil(response.data.totalRecords / 10)
        context.commit('setUsers', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    async postUser (context, payload) {
      await context.rootState.authAxios.post('/Users/Register',
        payload
      )
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async logout (context, payload) {
      await context.rootState.authAxios.get('/Users/Logout')
    },
    async updateUser (context, payload) {
      await context.rootState.authAxios.put(`/Users/Update/${payload.id}`, {
        username: payload.username,
        email: payload.email,
        password_hash: payload.oldPassword,
        new_password: payload.newPassword,
        activated: payload.activated
      })
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteUser (context, payload) {
      await context.rootState.authAxios.put(`/Users/DeleteUser/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async exportExcel (context, { filteredTerm, filteredStatus }) {
      await context.rootState.authAxios.get('/Users/UserReport', 
        { responseType: 'blob',
          params: {
            filteredTerm: filteredTerm,
            filteredStatus: filteredStatus
          }
        })
        .then((res) => {
          const filename = res.headers['content-disposition']
            .split(';')
            // eslint-disable-next-line
            .find(function (el) {
              if (el.includes('filename=')) return el
            })
            .replace('filename=', '')
            .trim()
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel;charset=utf-8'
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename) // or any other extension
          document.body.appendChild(link)
          link.click()

          // Cleanup
          link.remove()
          window.URL.revokeObjectURL(url)
        }).catch((error) => {
          if (error.response.data.error_message) {
            showError(error.response.data.error_message)
          } else {
            showError('Đã xảy ra lỗi không mong muốn')
          }
        })
    }
  }
}
